<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Help</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <ion-list>
    <ion-item (click)="showChat()" detail="true">
      <ion-icon name="chatbubbles" slot="start"></ion-icon>
      <ion-label>Chat with us</ion-label>
    </ion-item>
    <ion-item (click)="redirectToHelpCenterLink()" detail="true">
      <ion-icon name="help-circle" slot="start"></ion-icon>
      <ion-label>Visit our Help Center</ion-label>
    </ion-item>

  </ion-list>
</ion-content>
